export const translations = {
  en: {
    shetab: "Shetab",
    shetabGateway: " Shetab Gateway",
    shaparak: "Shaparak",
    perfectMoney: "Perfect Money",
    cardToCard: "Card to Card",
    tether: "Tether",
    enterCardAndMobile: "Please enter your card and mobile number",
    cardNumber: "Card Number",
    enter16DigitCardNumber: "Please enter your 16 digit card number",
    mobilePhone: "Mobile Phone",
    enterMobilePhoneNumber: "Please enter your mobile phone number",
    selectAmount: "Select Amount",
    enterSelectedAmount: "Please enter your selected amount",
    cancel: "Cancel",
    nextStep: "Next Step",
    register: "Register",
    onlyEnterCardNumberAndMobile:
      "Please only enter your card number and mobile",
    invalidCardNumber: "Invalid card number",
    saderatNoGatewaySupport: "Saderat bank cards are not supported temporarily",
    payingAmount: "Paying Amount",
    withThisStepYouDontNeedTheValidationCode:
      "With this step you don't need the validation code for the next steps",
    codeSentTo: "Code sent to ",
    changeNumber: "Change Number",
    enterTheSentCode: "Enter the sent code",
    ToUseThisSwitchYouNeedToEnterOwnerNationalCode:
      "To use this switch you need to enter the owner national code",
    ifYouDidntReceiveCode: "If you didn't receive the code",
    erase: "Erase",
    paymentInformation: "Payment Information",
    enterPaymentInformation: "Enter your payment information",
    shopName: "Shop Name",
    caspianPay: "Caspian Pay",
    timeRemaining: "Time Remaining",
    amountToPay: "Amount to Pay",
    toman: "Toman",
    cvv2Title: "CVV2",
    enterCvv2CodeInsertedIntoYourCard:
      "Enter the 3 or 4 digit cvv2 code inserted into your card",
    cardExpireTime: "Card Expire Time",
    enterTheMonthAndYearOfCardExpiration:
      "Enter the month and year of card expiration",
    month: "Month",
    year: "Year",
    cardSecondInternetPassword: "Card Second Internet Password",
    enterTheSentPooyaPassword: "Enter the sent pooya password",
    receivePassword: "Receive Password",
    saveCArdNumberAndExpireDate: "Save Card Number And Expire Date",
    clubBaz: "Club Baz",
    onlyEnterCardPhoneNumberAndGatewayType:
      "Please only enter your card phone number and select the gateway type",
    receiverName: "Receiver Name",
    paymentSuccessful: "Payment SuccessFull",
    bank: "Bank",
    paymentFailed: "Payment Failed",
    dateAndTime: "Date and Time",
    trackingNumber: "Tracking Number",
    transactionAmount: "Transaction Amount",
    yourTransactionSuccessfullyDone: "Your transaction successfully done",
    yourTransactionFailed: "Your transaction failed",
    withPressingTheTryAgainButtonYouCanTryAnotherSwitch:
      "With pressing the try again button you can try another switch",
    tryAgain: "Try Again",
    transferringToTheReceiverPage: "Transferring to the receiver page",
    accept: "Accept",
    nationalCode: "National Code",
    enterTheOwnerNationalCode: "Enter the owner national code",
    forRegister: "For Register",
    phoneNumberAccept: "Phone Number Accept",
    enterTheSentCodeToYourMobilePhone:
      "Enter the sent code to your mobile phone",
    payment: "Payment",
    pleaseEnterCardInfo: "Please enter your card info",
    transactionResult: "Transaction Result",
    onlyEnterVoucherNumberAndActivationCode:
      "Please only enter the voucher number and activation code",
    cardToCardGateway: "Card To Card Gateway",
    onlyAfterThePaymentEnterYourCardNumber:
      "Please enter your card number after the payment",
    enterPayingAmountAndCardNumber:
      "Please enter the paying amount and your card number",
    tetherGateway: "Tether Gateway",
    vatanGateway: "Vatan Gateway",
    tronGateway: "Tron Gateway",
    onlyReceiveYourWalletAndDeposit:
      "You just need to get your wallet address and deposit",
    depositAmountToTheWalletBelow: "Deposit to the wallet below",
    shaparakGateway: "Shaparak Gateway",
    enterCardInfoAndPassword: "Please enter your card info and password",
    addCard: "Add Card",
    submitCard: "Submit Card",
    enterTheCardNumberCorrectly: "Please enter the card number correctly",
    thisCardIsRegisteredBefore: "This card is registered before",
    approveUser: "Approve User",
    creatingASafeSpaceForUserPayments:
      "Creating a safe space for user payments",
    twoCardNumbersThatBelongToYouIsNeeded:
      "Two card numbers that belong to you is needed",
    afterApprovingBySupporterYouCanUseTheService:
      "After approving by supporter you can use the service",
    approvingYourProfileWillTakeMaximum20Minutes:
      "Approving your profile will take maximum 20 minutes",
    submitInformation: "Submit Information",
    identityApproved: "Identity Approved",
    selectTransactionAmount: "Select Transaction Amount",
    back: "Back",
    eachTetherPriceInThisMoment: "Each Tether price at this moment",
    eachVatanPriceInThisMoment: "Each Vatan coin price at this moment",
    isToman: "Toman",
    minimumTetherBuyAmount: "Minimum Tether buy amount is",
    minimumVatanBuyAmount: "Minimum Vatan coin buy amount is",
    isDollar: "Us-Dollar",
    eachTronPriceInThisMoment: "Each Tron price at this moment",
    minimumTronBuyAmount: "Minimum Tron buy amount is",
    isTron: "Tron",
    attentionTransactionsWith: "Attention transactions with",
    type: "Type",
    and: "and",
    onlyAreAcceptable: "only are acceptable",
    tetherPurchaseInfo:
      "If you wish to purchase via Tether, a dedicated wallet number will be assigned to you for a period of 4 hours. The result of your transaction will be announced to the receiving site between 2 to 10 minutes from the time of purchase.",
    tetherErc20PurchaseInfo:
      "If you wish to purchase via Ethereum, a dedicated wallet number will be assigned to you for a period of 4 hours. The result of your transaction will be announced to the receiving site between 2 to 10 minutes from the time of purchase.",
    followingWalletOnlyFor: "Following wallet is usable only",

    once: "Once",
    acceptableCryptoTransaction:
      "Your successful transaction is considered and for your next transactions, be sure to reopen the payment page and press the show wallet button",
    showWallet: "Show Wallet",
    helper: "Helper",
    eachTetherPrice: "Each Tether price",
    eachVatanPrice: "Each Vatan coin price",
    yourDedicatedWallet: "Your dedicated wallet",
    yourDedicatedWalletAddressWillExpireIn:
      "Your dedicated wallet address will expire in",
    attention: "Attention",
    pleaseKeepInMindTransactionWithType:
      "Please keep in mind that transactions with type",
    tronPurchaseInfo:
      "If you wish to purchase via Tron, a dedicated wallet number will be assigned to you for a period of 4 hours. The result of your transaction will be announced to the receiving site between 2 to 10 minutes from the time of purchase.",
    eachTronPrice: "Each Tron price",
    tron: "Tron",
    selectYourCurrency: "Select your currency",
    selectYourPayMethod: "Select your payment method",
    youOnlyNeedToEnterYourCardNumber: "You only need to enter your card number",
    eachPerfectMoneyDollarBuyPrice: "Each perfect money dollar buy price",
    enterVoucherNumberAndActivationCode:
      "Enter Voucher Number And Activation Code",
    digit10Code: "10 Digit Code",
    digit16Code: "16 Digit Code",
    voucherNumber: "Voucher Number",
    activationCode: "Activation Code",
    securityCode: "Security Code",
    enterYourVoucherNumber: "Enter Your Voucher Number",
    enterTheActivationCodeSentToYourPhone:
      "Enter The Activation Code Sent To Your Phone",
    enterTheSecurityCodeInTheContainerBelow:
      "Enter The Security Code In The Container Below",
    requestedTransactionIsInvalid: "Requested transaction is invalid",
    shetabAlertInfo:
      "The mobile phone number and bank card entered must belong to a national code. If the deposit is not successful, without leaving the payment page, click the try again button to provide you with a different bank switch service",
    systemError: "System Error",
    tryThePaymentStepsAgain: "Try the payment steps again",
    connectionToServerIsNotEstablishedTryAgain:
      "Connection to server is not established, try again",
    changeIpAlertError: "Change IP Error",
    IUnderstand: "I Understand",
    ipChangeDuringPaymentAndBankNotResponding:
      "Due to the change of your IP during payment or the bank not responding, your connection has been disconnected! Please try again",
    tryYourPaymentWithADifferentSwitch:
      "Try your payment with a different switch you are routing on",
    pleaseWait: "Please wait",
    selectTheTransactionAmount: "Select the transaction amount",
    second: "Second",
    minute: "Minute",
    hour: "Hour",
    hoursAnd: "Hours",
    minutesAnd: "Minutes",
    change: "change",
    pleaseKeepInMindThereIsAChanceOf:
      "Please keep in mind there is a chance of",
    theDestinationCardNumberPleaseCheckThisPageBeforeEachDeposit:
      "the destination card number, please check this page before each deposit",
    otherwiseIfYouDepositToTheOldCardNumberYourAccountCouldNotBeCharged:
      "Otherwise, if you deposit to the old card number, your account could not be charged",
    andAfterPaymentWait5MinutesAndEnterYourCardNumber:
      "And after payment, wait <span class='red-text font-weight-bold'>5 minutes</span> and enter your card number. If you are sure the transaction was successful and you encounter an error, please <span class='red-text font-weight-bold'>retry</span> the payment verification steps",
    showCard: "Show Card",
    enterAmountAndYourCardNumber: "Enter the amount and your card number",
    checkPayment: "Check Payment",
    pleaseKeepInMindThereIsAChanceOfCardNumberChange:
      "Please keep in mind there is a chance of <span class='alert-text font-weight-bold'>changing the number</span> of the destination card. Please check this page before each deposit. Otherwise, if you deposit to the old card numbers, your account may not be charged. And after payment, wait <span class='alert-text font-weight-bold'>5 minutes</span> and enter your card number. If you are sure the transaction was successful and you encounter an error, please <span class='alert-text font-weight-bold'>retry</span> the payment verification steps.",
    enterThePayingAmount: "Enter the paying amount",
    submit: "Submit",
    centralBankDirectiveForSecurity:
      "According to the directive of the Central Bank for transfer security, the source card must be registered once in the Central Bank's online system. For this, enter the code sent to your mobile phone number and the card's expiration date.",
    maximum6CharactersAllowed: "Maximum 6 characters allowed",
    maximum10CharactersAllowed: "Maximum 10 characters allowed",
    confirmation: "Confirmation",
    accountToAccount: "Account to Account",
    accountToAccountGateway: "Account to Account Gateway",
    accountToAccountBankSelect: "Select the bank you want to transfer to",
    cardToCardBankSelect: "Select the bank you want to card to card to",
    accountToAccountInfo:
      "Please note that the account number may <b style='color:red;'>change</b> at any time, so check the destination account before each deposit.",
    accountToAccountAlert:
      "Otherwise, if you deposit to the old account number, your user account cannot be credited. Also, wait <b style='color:red;'>10 minutes</b> after payment and enter your card number. If you are sure the transaction was successful and you encounter an error, <b style='color:red;'>repeat</b> the payment verification steps.",
    showAccountNumber: "Show Account Number",
    accountNumber: "Account Number",
    onlyAfterThePaymentEnterYourAccountNumber:
      "Please enter your account number after the payment",
    enterPayingAmountAndAccountNumber: "Please enter amount and account number",
    indirect: "Indirect",
    gardeshgari: "Gardeshgari",
    refah: "Refah",
    keshavarzi: "Keshavarzi",
    noActiveMethodsIsAvailable: "There is no active methods available",
    tejarat: "Tejarat",
    sepah: "Sepah",
    saman: "Saman",
    shaparakCommissionFee:
      "The fee for this payment method is <span class='red-text'>{shaparakCommissionFee}</span> percent",
    vouchers: "Vouchers",
    vouchersNumber: "Vouchers Number",
    characterNumber23: "23 character number",
    eachVouchersDollarBuyPrice: "Each U-dollar voucher buy price",
    onlyEnterVouchersNumber: "Please only enter the vouchers number",
    enterYourVouchersNumber: "Enter your vouchers number",
    submitNationalCode: "Submit National Code",
    confirm: "Confirm",
    crypto: "Crypto",
    vatan: "Vatan",
  },
  fa: {
    crypto: "کریپتو",

    enterYourVouchersNumber: "کد یو ووچرز خود را وارد کنید",
    onlyEnterVouchersNumber: "لطفا فقط کد یو ووچرز را وارد کنید",
    eachVouchersDollarBuyPrice: "قیمت خرید هر دلار یو ووچر",
    characterNumber23: "23 رقمی",
    vouchersNumber: "کد یو ووچر",
    vouchers: "یو ووچر",
    tejarat: "تجارت",
    centralBankDirectiveForSecurity:
      "به دستور بانک مرکزی برای امنیت انتقال وجه، کارت مبدا باید یکبار در سامانه آنلاین بانک مرکزی ثبت شود. برای این کار در کد ارسال شده به شماره تلفن همراه و تاریخ انقضا کارت خود را وارد کنید.",
    submit: "ثبت",
    youOnlyNeedToEnterYourCardNumber: "کافیست شماره کارت خود را وارد کنید",
    bank: "بانک",
    shaparak: "شاپرک",
    shetabGateway: " درگاه شتاب",
    shetab: "شتاب",
    perfectMoney: "پرفکت مانی",
    cardToCard: "کارت به کارت",
    tether: "تتر",
    enterCardAndMobile: " شماره موبایل و کارت خود را وارد کنید",
    cardNumber: "شماره کارت",
    enter16DigitCardNumber: " شماره کارت 16 رقمی خود را وارد کنید",
    mobilePhone: "تلفن همراه",
    enterMobilePhoneNumber: "شماره تلفن همراه خود را وارد کنید",
    selectAmount: "انتخاب مبلغ",
    enterSelectedAmount: "مبلغ مورد نظر خود را وارد کنید",
    cancel: "انصراف",
    nextStep: "مرحله بعد",
    register: "ثبت نام",
    onlyEnterCardNumberAndMobile: "کافیست شماره کارت و موبایل را وارد کنید",
    invalidCardNumber: "شماره کارت نامعتبر است",
    saderatNoGatewaySupport: "کارت های بانک صادرات موقتا پشتیبانی نمیشود",
    payingAmount: "مبلغ پرداختی",
    withThisStepYouDontNeedTheValidationCode:
      "با تایید این مرحله دیگر نیاز به کد تایید برای مراجعات بعدی نخواهد داشت",
    codeSentTo: "کد ارسال شده به ",
    changeNumber: "تغییر شماره",
    enterTheSentCode: "کد ارسال شده را وارد کنید",
    ToUseThisSwitchYouNeedToEnterOwnerNationalCode:
      "برای استفاده از این سوییچ باید کد ملی صاحب کارت را وارد کنید",
    enterTheOwnerNationalCode: "کد ملی مالک سیم کارت را وارد کنید",
    ifYouDidntReceiveCode: "اگر کد را دریافت نکردید",
    erase: "پاک کردن",
    paymentInformation: "اطلاعات پرداخت",
    enterPaymentInformation: "اطلاعات پرداخت خود را وارد کنید",
    shopName: "نام فروشگاه",
    caspianPay: "کاسپین پی",
    timeRemaining: "زمان باقی مانده",
    amountToPay: "مبلغ قابل پرداخت",
    toman: "تومان",
    cvv2Title: "شماره شناسایی دوم",
    enterCvv2CodeInsertedIntoYourCard:
      "شماره سه یا چهار رقمی cvv2 درج شده روی کارت را وارد کنید",
    cardExpireTime: "زمان انقضای کارت",
    enterTheMonthAndYearOfCardExpiration: "ماه و سال انقضای کارت را وارد کنید",
    month: "ماه",
    year: "سال",
    cardSecondInternetPassword: "رمز دوم اینترنتی کارت",
    enterTheSentPooyaPassword: "رمز پویا ارسال شده  را وارد کنید",
    receivePassword: " دریافت رمز",
    saveCArdNumberAndExpireDate: "ذخیره شماره کارت و تاریخ انقضا",
    clubBaz: "کلاب باز",
    onlyEnterCardPhoneNumberAndGatewayType:
      "کافیست شماره کارت و موبایل را وارد و نوع درگاه را انتخاب کنید",
    receiverName: "نام گیرنده",
    paymentSuccessful: "پرداخت موفق",
    paymentFailed: "پرداخت ناموفق",
    dateAndTime: "تاریخ و زمان",
    trackingNumber: "شماره پیگیری",
    transactionAmount: "مبلغ تراکنش",
    yourTransactionSuccessfullyDone: "تراکنش شما با موفقیت انجام شد",
    yourTransactionFailed: "تراکنش شما انجام نشد",
    withPressingTheTryAgainButtonYouCanTryAnotherSwitch:
      "با فشردن دکمه تلاش مجدد میتوانید تراکنش خود را با  سوییچ دیگری امتحان کنید",
    tryAgain: "تلاش مجدد",
    transferringToTheReceiverPage: "در حال انتقال به صفحه پذیرنده",
    accept: "تایید",
    forRegister: "برای ثبت نام",
    phoneNumberAccept: "تایید شماره تلفن همراه",
    enterTheSentCodeToYourMobilePhone:
      "کد ارسال شده به تلفن همراه خود را وارد کنید",
    payment: "پرداخت",
    pleaseEnterCardInfo: "لطفا اطلاعات کارت خود را وارد کنید",
    transactionResult: "نتیجه تراکنش",
    onlyEnterVoucherNumberAndActivationCode:
      "کافیست شماره ووچر و کد فعال سازی را وارد کنید",
    cardToCardGateway: "درگاه کارت به کارت",
    onlyAfterThePaymentEnterYourCardNumber:
      "کافیست پس از پرداخت شماره کارت خود را وارد کنید",
    enterPayingAmountAndCardNumber:
      "لطفا مبلغ پرداختی و شماره کارت خود را وارد کنید",
    tetherGateway: "درگاه تتر",
    vatanGateway: "درگاه وطن",
    indirectGateway: "درگاه غیرمستقیم",
    tronGateway: "درگاه ترون",
    onlyReceiveYourWalletAndDeposit:
      "کافیست کیف پول اختصاصی را دریافت کرده و واریز را انجام دهید",
    depositAmountToTheWalletBelow:
      "مبلغ مورد نظر را به کیف پول اختصاصی زیر وارد نمایید",
    shaparakGateway: "درگاه شاپرک",
    enterCardInfoAndPassword: " لطفا اطلاعات کارت و رمز خود را وارد کنید",
    addCard: "افزودن کارت",
    submitCard: "ثبت کارت",
    enterTheCardNumberCorrectly: "لطفا شماره کارت را به درستی وارد کنید",
    thisCardIsRegisteredBefore: "این کارت قبلا ثبت شده است",
    approveUser: "تایید کاربر",
    creatingASafeSpaceForUserPayments:
      "به منظور ایجاد شرایط امن برای پرداخت کاربران",
    twoCardNumbersThatBelongToYouIsNeeded:
      "نیاز است ۲ شماره کارت بانکی که متعلق به شما است را وارد کنید",
    afterApprovingBySupporterYouCanUseTheService:
      "بعد از تایید توسط پشتیبان میتوانید از سرویس استفاده کنید",
    approvingYourProfileWillTakeMaximum20Minutes:
      "بررسی پروفایل شما حداکثر 20 دقیقه زمان خواهد برد",
    submitInformation: "ثبت اطلاعات",
    identityApproved: "احراز شده",
    selectTransactionAmount: "مبلغ تراکنش را انتخاب کنید",
    back: "بازگشت",
    eachTetherPriceInThisMoment: "قیمت هر تتر در این لحظه",
    eachVatanPriceInThisMoment: "قیمت هر کوین وطن در این لحظه",
    isToman: "تومان میباشد",
    minimumTetherBuyAmount: "حداقل خرید برای تتر",
    minimumVatanBuyAmount: "حداقل خرید برای کوین وطن",
    isDollar: "دلار میباشد",
    eachTronPriceInThisMoment: "قیمت هر ترون در این لحظه",
    minimumTronBuyAmount: "حداقل خرید برای ترون",
    isTron: "ترون میباشد",
    attentionTransactionsWith: "توجه فرمایید که تراکنش‌های",
    type: "از نوع",
    and: "و",
    onlyAreAcceptable: "فقط قابل قبول میباشد",
    followingWalletOnlyFor: "کیف پول مورد نظر فقط برای",
    tetherPurchaseInfo:
      "در صورت تمایل به خرید از طریق تتر، به شما یک شماره کیف پول اختصاصی برای مدت 4 ساعت اختصاص داده میشود. نتیجه تراکنش شما بین 2 تا 10 دقیقه از زمان خرید به سایت پذیرنده اعلام خواهد شد.",
    tetherErc20PurchaseInfo:
      "در صورت تمایل به خرید از طریق اتریوم به شما یک شماره کیف پول اختصاصی برای مدت 4 ساعت اختصاص داده میشود. نتیجه تراکنش شما بین 2 تا 10 دقیقه از زمان خرید به سایت پذیرنده اعلام خواهد شد.",
    once: "یک بار",
    acceptableCryptoTransaction:
      "تراکنش موفق شما را در نظر گرفته شده و برای تراکنشهای بعدی خود حتما مجدداً صفحه پرداخت را باز کنید و نمایش کیف پول را بزنید",
    showWallet: "نمایش کیف پول",
    helper: "راهنما",
    eachTetherPrice: "قیمت هر تتر",
    eachVatanPrice: "قیمت هر کوین وطن",
    yourDedicatedWallet: "کیف پول اختصاصی شما",
    yourDedicatedWalletAddressWillExpireIn:
      "مدت زمان باقی مانده تا منقضی شدن آدرس کیف پول اختصاصی شما",
    attention: "توجه",
    pleaseKeepInMindTransactionWithType:
      "لطفا توجه داشته باشید که تراکنش‌ها از نوع",
    tronPurchaseInfo:
      "در صورت تمایل به خرید از طریق ترون، به شما یک شماره کیف پول اختصاصی برای مدت 4 ساعت اختصاص داده میشود. نتیجه تراکنش شما بین 2 تا 10 دقیقه از زمان خرید به سایت پذیرنده اعلام خواهد شد.",
    eachTronPrice: "قیمت هر ترون",
    tron: "ترون",
    selectYourCurrency: "ارز مورد نظر خود را انتخاب نمایید",
    selectYourPayMethod: "روش پرداخت مورد نظر خود را انتخاب نمایید",
    eachPerfectMoneyDollarBuyPrice: "قیمت خرید هر دلار پرفکت مانی",
    enterVoucherNumberAndActivationCode:
      "شماره ووچر و کد فعال سازی را وارد کنید",
    digit10Code: "کد 10 رقمی",
    digit16Code: "کد 16 رقمی",
    voucherNumber: "شماره ووچر",
    activationCode: "کد فعال سازی",
    securityCode: "کد امنیتی",
    enterYourVoucherNumber: "شماره ووچر خود را وارد کنید",
    enterTheActivationCodeSentToYourPhone:
      "کد فعال سازی ارسال شده به تلفن همراه خود را وارد کنید",
    enterTheSecurityCodeInTheContainerBelow:
      "کد امنیتی داخل کادر زیر را وارد کنید",
    requestedTransactionIsInvalid: "تراکنش درخواستی نامعتبر می‌باشد",
    shetabAlertInfo:
      "شماره موبایل و کارت بانکی وارد شده باید متعلق به یک کد ملی باشد. در صورت عدم موفقیت در واریز وجه، بدون خارج شدن از صفحه پرداخت روی دکمه تلاش مجدد کلیک کنید تا سرویس سوییچ بانکی متفاوتی را در اختیارتان قرار دهد",
    systemError: "خطای سیستمی",
    tryThePaymentStepsAgain: "مراحل پرداخت را دوباره امتحان کنید",
    connectionToServerIsNotEstablishedTryAgain:
      "اتصال به سرور برقرار نشد، دوباره امتحان کنید",
    changeIpAlertError: "خطای تغییر آیپی",
    IUnderstand: "متوجه شدم",
    ipChangeDuringPaymentAndBankNotResponding:
      "به دليل تغيير آيپى شما در حين پرداخت و يا عدم پاسخگويى بانك ارتباط شما قطع شده! لطفا مجدد تلاش کنید",
    tryYourPaymentWithADifferentSwitch:
      "لطفا پرداخت خود را با سوییچ دیگری که به آن هدایت می شوید، امتحان کنید",
    pleaseWait: "لطفا منتظر بمانید",
    selectTheTransactionAmount: "مبلغ تراکنش را انتخاب کنید",
    second: "ثانیه",
    minute: "دقیقه",
    hour: "ساعت",
    hoursAnd: "ساعت و",
    minutesAnd: "دقیقه و",
    change: "تغییر",
    pleaseKeepInMindThereIsAChanceOf:
      "توجه فرمایید با توجه به اینکه هر لحظه امکان",
    theDestinationCardNumberPleaseCheckThisPageBeforeEachDeposit:
      " شماره کارت مقصد وجود دارد. قبل از هر بار واریز این صفحه را چک کنید",
    otherwiseIfYouDepositToTheOldCardNumberYourAccountCouldNotBeCharged:
      "در غیر این صورت اگر واریزی به شماره کارت قدیمی داشته باشید امکان شارژ حساب کاربریتان وجود ندارد",
    andAfterPaymentWait5MinutesAndEnterYourCardNumber:
      "و همچنین پس از پرداخت <span class='red-text font-weight-bold'>۵ دقیقه</span> صبر کنید و شماره کارت خود را وارد کنید. و در صورتی که از موفقیت آمیز بودن تراکنش خود اطمینان داشتید و با خطا مواجه شدید، مراحل بررسی پرداخت را <span class='red-text font-weight-bold'> مجدداً </span> انجام دهید",
    showCard: "نمایش کارت",
    enterAmountAndYourCardNumber: "مبلغ و شماره کارت خود را وارد کنید",
    checkPayment: "بررسی پرداخت",
    pleaseKeepInMindThereIsAChanceOfCardNumberChange:
      "توجه فرمایید با توجه به اینکه هر لحظه امکان <span class='alert-text font-weight-bold'>تغییر شماره</span> کارت مقصد وجود دارد. قبل از هر بار واریز این صفحه را چک بفرمایید. در غیر این صورت اگر واریزی به کارتهای قدیم داشته باشید امکان شارژ حساب کاربریتان وجود ندارد. و همچنین پس از پرداخت <span class='alert-text font-weight-bold'>۵ دقیقه</span> صبر کنید و شماره کارت خود را وارد کنید. و در صورتی که از موفقیت آمیز بودن تراکنش خود اطمینان داشتید و با خطا مواجه شدید، مراحل بررسی پرداخت را <span class='alert-text font-weight-bold'>مجدداً</span> انجام دهید.",
    enterThePayingAmount: "مبلغ پرداختی را وارد کنید",
    maximum6CharactersAllowed: "حداکثر 6 کاراکتر مجاز است",
    maximum10CharactersAllowed: "حداکثر 10 کاراکتر مجاز است",
    confirmation: "تاییدیه",
    accountToAccount: "حساب به حساب",
    accountToAccountGateway: "درگاه حساب به حساب",
    accountToAccountBankSelect:
      "برای حواله حساب به حساب بر روی بانک مورد نظر کلیک نمایید",
    cardToCardBankSelect: "برای کارت به کارت بر روی بانک مورد نظر کلیک نمایید",
    accountToAccountInfo:
      "توجه فرمایید با توجه به اینکه هر لحظه امکان <b style='color:red;'>تغییر</b> شماره حساب وجود دارد، قبل از هر بار واریز حساب مقصد را چک بفرمایید",
    accountToAccountAlert:
      "در غیر این صورت اگر واریزی به شماره حساب قدیمی داشته باشید، امکان شارژ حساب کاربریتان وجود ندارد و همچنین پس ار پرداخت <b style='color:red;'>۱۰ دقیقه</b> صبر کنید و شماره کارت خود را وارد کنید و  در صورتی که از موفقیت‌آمیز بودن تراکنش خود اطمینان داشتید و با خطا مواجه شدید مراحل بررسی پرداخت را <b style='color:red;'>مجددا</b> انجام دهید",
    showAccountNumber: "نمایش شماره حساب",
    accountNumber: "شماره حساب",
    onlyAfterThePaymentEnterYourAccountNumber:
      "کافیست پس از پرداخت شماره حساب خود را وارد کنید",

    enterPayingAmountAndAccountNumber:
      "لطفا مبلغ پرداختی و شماره حساب خود را وارد کنید",

    indirect: "غیر مستقیم",
    gardeshgari: "گردشگری",
    refah: "رفاه",
    saman: "سامان",
    keshavarzi: "کشاورزی",
    sepah: "سپه",
    noActiveMethodsIsAvailable:
      "در حال حاضر متد پرداخت غیر مستقیم در دسترس نمی باشد",
    shaparakCommissionFee:
      "کارمزد این روش پرداخت <span class='red-text'>{shaparakCommissionFee}</span> درصد میباشد",
    submitNationalCode: "ثبت کد ملی",
    nationalCode: "کد ملی",
    confirm: "تایید",
    vatan: "وطن",
  },
};
